import { HOST } from '../constants';

export const VERIFY_EMAIL = `${HOST}/verify_email`;
